import API from '../Services/API';
import Model from './Model';

const useWebsite = (alwaysRefresh) => {
    return Model({
        stateKey: 'website',
        alwaysRefresh: alwaysRefresh,
        returnDataKey: 'website',
        fetchData: () => API.get('/website'),
        registerAdditionalMethods: (opts) => {
            return {
                changeType: (data) => {
                    const website = opts.model();
                    return opts.wrapUpdateCall(
                        () => API.post(`/website/${website.type ? 'type' : 'initialise'}`, data),
                        'Website type updated',
                        true,
                    );
                },
                changeTheme: (theme, color) => {
                    return opts.wrapUpdateCall(
                        () => API.post('/website/theme', {theme, color}),
                        'Website theme updated',
                        true,
                    );
                },
                changeDomain: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post('/website/domain', data),
                        'Website updated',
                        true,
                    );
                },
                updateContent: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post('/website/update', data),
                        'Website updated',
                        true,
                    );
                },
                updateWidgetOptions: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post('/website/widgetOptions', data),
                        'Widget options updated',
                        true,
                    );
                },
                addCustomDomain: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post('/website/custom-domain', data),
                        'Custom domain added',
                        true,
                    );
                },
                removeCustomDomain: () => {
                    return opts.wrapUpdateCall(
                        () => API.delete('/website/custom-domain'),
                        'Custom domain removed',
                        true,
                    );
                },
                checkCustomDomainRedirect: (forceChange) => {
                    return opts.wrapUpdateCall(
                        () => API.post('/website/custom-domain/redirect', {forceChange}),
                        'Custom domain redirect updated',
                        true,
                    );
                }
            }
        },
        defaultLoadingError: 'Failed to load website data',
    })
}

const useStats = (alwaysRefresh) => {
    return Model({
        stateKey: ['website', 'stats'],
        alwaysRefresh: alwaysRefresh,
        returnDataKey: 'stats',
        fetchData: () => API.get('/website/stats'),
    });
}

export {
    useWebsite,
    useStats,
};
